module.exports = __webpack_public_path__ + "static/pandamuslin-3596102b54461130f10ca13b503db5ae.jpeg";